import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'se-timeline-toggle',
  templateUrl: './se-timeline-toggle.component.html',
  styleUrl: './se-timeline-toggle.component.scss'
})
export class SeTimelineToggleComponent implements OnChanges {
    @Input() toggleOpen : boolean;
    @Output() toggleTimeline : EventEmitter<boolean> = new EventEmitter<boolean>();

    tooltip : string = ''
    constructor (private translate : TranslateService) { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes.toggleOpen) {
            this.tooltip = this.toggleOpen ? this.translate.instant('hideTimeline') : this.translate.instant('showTimeline');
        }
    } 

    _showHideTimeline () {
        this.toggleOpen = !this.toggleOpen
        this.toggleTimeline.emit(this.toggleOpen);
    }
}
